/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PostV1UsersPasswordResetsMutationRequest, PostV1UsersPasswordResetsMutationResponse, PostV1UsersPasswordResets404, PostV1UsersPasswordResets422 } from "../../../types/PostV1UsersPasswordResets.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPostV1UsersPasswordResetsUrlClient() {
  const res = { method: 'POST', url: `/v1/users/password_resets` as const }
  return res
}

/**
 * @summary Reset user password
 * {@link /v1/users/password_resets}
 */
export async function postV1UsersPasswordResetsClient(data: PostV1UsersPasswordResetsMutationRequest, config: Partial<RequestConfig<PostV1UsersPasswordResetsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostV1UsersPasswordResetsMutationResponse, ResponseErrorConfig<PostV1UsersPasswordResets404 | PostV1UsersPasswordResets422>, PostV1UsersPasswordResetsMutationRequest>({ method : "POST", url : getPostV1UsersPasswordResetsUrlClient().url.toString(), data : requestData, ... requestConfig })
  return res
}